import React from 'react'
import { Link } from 'react-router-dom'

const BlackBtn = ({title, className, to}) => {
  return <Link className={`bg-black rounded-full p-2 text-[13px] px-4 sm:p-4 text-white text-center ${className} transition-all duration-500 hover:bg-[#ecd870] hover:text-black hover:shadow-2xl `} to={to}>{title}</Link>
}

export default BlackBtn
